import { FunctionComponent, useState } from "react";
import { ListGroupsContainer } from "./styled.components";
import ListParam from "Components/ListParam";

type ListsGroupProps = {
    params: any
    handleOnCheckAll: (e: any) => void
    handleOnCheckChange: (e: any) => void
}

const ListsGroup: FunctionComponent<ListsGroupProps> = ({ params, handleOnCheckAll, handleOnCheckChange }) => {

    const handleRenderListContainers = (param: any, index: number) => {
        //@ts-ignore
        let idsGroupValues: any = [...new Set(param.segmentacionValores.map((item: any) => item.idValorAnt))]
        let groupValues: any = idsGroupValues.map((item: any) => {
            const paramAnt: any = params.find((element: any) => element.codigoParametro === param.codigoParametroAnt)
            const valueAnt: any = paramAnt?.segmentacionValores.find((element: any) => element.idValor === item)
            return {
                idGroup: item,
                name: valueAnt?.valorDescripcion,
                visible: (!valueAnt) ? true : (valueAnt.segmentado === 1),
                values: param.segmentacionValores.filter((value: any) => value.idValorAnt === item)
            }
        })
        param.allChecked = validateAllChecked(groupValues)
        return (
            <ListParam
                param={param}
                key={`param${param.idParametro}`}
                groupValues={groupValues.sort((a: any, b: any) => a.name - b.name)}
                handleOnCheckAll={handleOnCheckAll}
                handleOnCheckChange={handleOnCheckChange}
            />
        )
    }

    const validateAllChecked = (groupValues: any) => {
        if (groupValues.filter((group: any) => group.visible).length === 0) {
            return false
        }
        let checked: boolean = true;
        groupValues.filter((group: any) => group.visible).forEach((group: any) => {
            group.values.forEach((value: any) => {
                if (value.segmentado !== 1) {
                    checked = false
                }
            })
        })
        return checked
    }

    return (<ListGroupsContainer>
        {params.map(handleRenderListContainers)}
    </ListGroupsContainer>)
}

export default ListsGroup;
